module.exports = __webpack_public_path__ + "jab/media/delete-warning.df190def.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/delete-warning.svg
// module id = 100
// module chunks = 0